module.exports = "pegasus/assets/spacer.gif";